<template>
	<div>
        <toast></toast>
		<div class="col-md-4 centre_sm_none pt-3 information_list" :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':!specail&&(viewToggle||!clickToggle)}">
			<div class="nano centre_content consult_left">
				<div class="nano-content" id="home_right_list" :class="{'cur':!viewToggle}">
                    <div id="consult_left_content" class="pl-3">
                        <i class="fa fa-mortar-board fa-lg mr-2"></i>Consulting
                        <span class="myBtn" @click='goback()' v-if="!viewToggle">Back</span>
                    </div>
					<div class="d-flex justify-content-around consult_details_figure row m-0">
						<div>
							<img class="rounded-circle img-thumbnail" :src="synopsies.photo" />
						</div>
						<div class="consult_figure_name">
							<h3>{{synopsies.name}}</h3>
							<p class="">{{synopsies.tags}}</p>
							<div class="consult_figure_titleBtn">
								<button class="btn btn_user-defined offer"   @click="refer($event,synopsies.spaceid,synopsies.name)" data-toggle="modal" data-target="#myModal"><i class="fa fa-comments-o" style="margin-right: 5px;"></i>Consulting</button>
								<button class="btn btn_user-defined offer"  @click="subscription($event,synopsies)">
<!--                                    <i :class="{ 'startrue': synopsies.collect }" v-if="!synopsies.collect" class="fa fa-star-o" style="margin-right: 5px;"></i>-->
                                    <i :class="{ 'startrue': synopsies.collect }" class="fa fa-star-o" style="margin-right: 5px;"></i>
                                    <span v-if="synopsies.collect">Followed</span>
                                    <span v-if="!synopsies.collect">Follow</span>
                                    <!--<i class="fa fa-star-o" style="margin-right: 5px;"></i>订阅</button>-->
                                </button>
							</div>
						</div>
					</div>



					<ul class="consult-list" style="margin-top: 80px;" >
						<li class="list-item" v-if="typeid==1"  v-for="(item,index) in column" @click="clickCategory(index)">
							<span v-if="index==0" class="cur">{{item}}</span>
							<span v-if="index==1" class="curr dropright" style="padding-right: 10px">{{item}}  </span>
						</li>
                        <li class="list-item"  v-if="typeid==2"  v-for="(item,index) in columns" @click="clickCategory(index)">
							<span v-if="index==0" class="cur">{{item}}</span>
							<span v-if="index==1" class="curr dropright" style="padding-right: 10px">{{item}}</span>
						</li>
                        <li class="list-item" v-if="typeid==3"   v-for="(item,index) in columnss" @click="clickCategory(index)">
							<span v-if="index==0" class="cur">{{item}}</span>
							<span v-if="index==1" class="curr dropright" style="padding-right: 10px">{{item}}  </span>
						</li>
					</ul>

					<ul class="list-group">
						<!-- 个人简介 -->
						<!--<li v-show="categoryIndex==0" class="list-group-item" v-html="synopsies.space.description"></li>-->

						<!-- 记者观点 -->
						<div>
						<li class="list-group-item">
							<ul class="list-unstyled">
								<li v-for='(value,key) in synopsisLists' class="media pb-3 pt-3 border-bottom mb-3" style="position: relative;">

									<a href="javascript:" class="list list-main">
										<div class="title-thumb" v-show="value.thumb.length>0">
											<img :src="value.thumb" />
										</div>
										<div class="media-body">
                                            <h5>
                                                <router-link class="f15 text-dark font-weight-bold" :to ="{name:'consultdetails',params :{contentid:value.id, name:alias}}">{{ value.title }}</router-link>
                                            </h5>
                                            <div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">
                                                <span>{{ value.description}}</span>
                                            </div>
                                            <div class="tag">
												<img :src="value.space.photo" />
												<span>{{value.space.name}}</span>
												<span>{{value.published}}</span>
											</div>
										</div>
									</a>
								</li>
                                <p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
							</ul>
                            <div v-if="synopsisLists.length ==0&&endShow" class="nodata text-center">
                                <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="" />
                                <p class="text-center p-2">loading</p>
                            </div>
						</li>
						</div>
					</ul>
				</div>
			</div>
		</div>
		<div class="col-md-8 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'d-none':!specail&&(viewToggle||clickToggle)}">

            <articles :author="synopsies.name" :typey="typeid" :myclickToggle="clickToggle" :description="synopsies.description" :advice="synopsies.advice" :spacecontent="synopsies.content"></articles>
		</div>


        <div class="modal fade" id="myModal">
            <div class="modal-dialog">
                <div class="modal-content">

                    <!-- 模态框头部 -->
                    <div class="modal-header">
                        <h4 class="modal-title">Consultation request for {{this.refsname}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- 模态框主体 -->
                    <div class="modal-body">
                        <form>
                            <input type="hidden" :value="this.refsid">
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Title</label>
                                <input type="text"  v-model="advisorytitle" class="col-md-6 form-control col-8">
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Content</label>
                                <textarea  v-model="advisorycontent" maxlength="400" class="form-control col-8">

						</textarea>
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-4 tc">Submitted by</label>
                                <input type="text" v-model="advisorycompany" class="col-md-6 form-control col-8">
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>User name</label>
                                <input  type="text" v-model="advisoryname" class="col-md-6 form-control col-8">
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>Mobile number</label>
                                <input  type="phone" v-model="advisoryphone" class="col-md-6 form-control col-8">
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-4 tc"><i class="reqiureClass">*</i>email</label>
                                <input  type="email" v-model="advisoryemail" class="col-md-6 form-control col-8">
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-4 tc">Address</label>
                                <input  type="text" v-model="advisoryaddress" class="col-md-6  col-8">
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-4 tc">Verification code</label>
                                <input type="text" v-model="advisorycapat" placeholder="Verification code" class="col-md-2 form-control col-8">
                                <img @click='refresh()' :src="codeUrl"  id="code" class="border ml-3" style="line-height: 38px;" alt="Verification code" width="65px" height="38px">

                            </div>
                            <div class="w-100 tc mt-3 mb-3">
                                <button @click="advisorysub" class="btn btn-primary" style="width: 100px;">Save</button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
	</div>
</template>
<script>
	import tollHint from './TollHint/TollHint.vue'
    import toast from './toast/Toast'
    import articles from './ArticleDetails/consultArticle.vue'

	export default({
		name: 'consultdetails',
		data: function() {
			return {
			    codeUrl:"https://en.imsilkroad.com/api/pc/captcha/"+Date.parse(new Date()),
				particulars: [],
				synopsies: [],
				consultMatter: [],
				page: 1,
				consultdeles:[],
				total_page: 1,
				synopsisLists: [],
				consultdet:'',
                startrue: false, //收藏
				newAuthor: '',
				column:['Reporter\'s view', 'Reporter profile/Investment advice'],
				columns:['Expert\'s view', 'Expert profile/Expert column'],
				columnss:['机构观点', '机构简介/最新观点'],
				categoryIndex:0,

                advisorytitle: '',
                advisorycontent: '',
                advisorycompany: '',
                advisoryname: '',
                advisoryphone: '',
                advisoryemail: '',
                advisorycapat: '',
                advisoryaddress: '',
                refsid:"",
                refsname:"",
                viewToggle:true,
                clickToggle:true,
                specail:false, //特殊处理 小于544px
                screenWidth:"",
                loadShow:false,
                endShow:false,
                alias: this.$route.params.name,
                typeid:1
			}
		},
		created: function() {

			var self = this;
            this.viewToggle=this.IsPC();
            if(self.IsPC()&&(document.body.clientWidth<=700)){
                self.specail=true
            }else{
                self.specail=false
            }

			this.$axios.post('/api/pc/specialist', {
				alias: this.alias,
                page: this.page
			}).then(data => { //风险投资
				var synopsis = data.data.space;
				self.synopsies = synopsis;
				var synopsisList = data.data.content;
				self.synopsisLists = synopsisList;
				self.total_page = data.data.max_page;
				self.typeid=synopsis.typeid;

			})

		},
		mounted() {
            document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
            const that = this;
            window.onresize = () => {
                return (() => {
                    that.screenWidth = document.body.clientWidth
                })()
            }
            this.$nextTick(function(){

                this.load()
            })
		},
		methods: {
            clickToggles(){
                this.clickToggle=false;
            },
            clickTogglesTrue(){
                this.clickToggle=true;
            },

            goback(){
                this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:1}})
            },
            subscription: function(e, cll) {

                let that = this;
                var acquirePitch = event.target.getAttribute("pitch");

                var el = e.target;
                //this.isSelected = !this.isSelected
                if($(el).parent().find('.fa-star-o').hasClass('startrue')) {

                    this.$axios.post('/api/pc/delspacecollect', { //取消订阅
                        spaceid: cll.spaceid,
                        typeid:cll.affiliation
                    }).then(data => {
                        if(data.data.state == true) {
                            $(".wrap").text('Successful Cancellation of Collection');
                            //$(el).find('i').removeClass('startrue');
                            $(".wrap").show().delay(1500).hide(100);
                            if(cll){
                                cll.collect=!cll.collect;
                            }
                        } else {
                            $(".wrap").text(data.data.error);
                            $(".wrap").show().delay(1500).hide(100);
                        }
                    })

                } else {
                    this.$axios.post('/api/pc/spacecollect', { //添加订阅
                        spaceid: cll.spaceid,
                        typeid:cll.affiliation
                    }).then(data => {
                        if(data.data.state == true) {
                            $(".wrap").text('Collection success');
                            //$(el).find('i').addClass('startrue');
                            $(".wrap").show().delay(1500).hide(100);
                            if(cll){
                                cll.collect=!cll.collect;
                            }
                        } else {
                            $(".wrap").text(data.data.error);
                            $(".wrap").show().delay(1500).hide(100);
                        }
                    })
                }

            },
            refresh(){
                $("#code").attr("src","https://en.imsilkroad.com/api/pc/captcha/"+ Date.parse(new Date()));
            },
            refer: function(e, refid, refname) {
                this.refsid = refid;
                this.refsname = refname;
            },
            advisorysub: function(e, refid) {
                let that = this;
                var reg = 11 && /^1[3578]\d{9}$|^147\d{8}$/;
                var regEmail = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
                if(that.advisorytitle == '') {
                    $(".wrap").text('The title should not be blank！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                } else if(that.advisorycontent == '') {
                    $(".wrap").text('Content cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                }else if(that.advisorycontent.length>400) {
                        $(".wrap").text('Content length should not exceed 400');
                        $(".wrap").show().delay(1500).hide(100);
                        return;
                }  else if(that.advisoryname == '') {
                    $(".wrap").text('Name cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                } else if(that.advisoryphone == '') {
                    $(".wrap").text('Mobile phone number cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                } else if(!reg.test(that.advisoryphone)) {
                        $(".wrap").text('Incorrect format of mobile phone number！');
                        $(".wrap").show().delay(1500).hide(100);
                        return;
                } else if(that.advisoryemail == '') {
                    $(".wrap").text('Mailbox cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                } else if(!regEmail.test(that.advisoryemail)) {
                        $(".wrap").text('The mailbox format is incorrect！');
                        $(".wrap").show().delay(1500).hide(100);
                        return;
                    }
                var src = $('#code').attr('src');
                var tmp = src.substring(src.lastIndexOf('/') + 1).match(/[^\/]*$/)[0];
                that.$axios.post('/api/pc/consult', {
                    // memberid: that.loginId,
                    spaceid: that.refsid,
                    title: that.advisorytitle,
                    content: that.advisorycontent,
                    company: that.advisorycompany,
                    name: that.advisoryname,
                    phone: that.advisoryphone,
                    email: that.advisoryemail,
                    address: that.advisoryaddress,
                    tmp: tmp,
                    captcha: that.advisorycapat
                }).then(data => {
                    if(data.data.state){
                        $(".wrap").text('Successful consultation！');
                        $(".wrap").show().delay(1500).hide(100);
                        $("#myModal").modal('hide');
                    }else{
                        $(".wrap").text(data.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }

                })
            },

			clickCategory(index){ // 这里我们传入一个当前值
                this.clickToggle=false;
                if (index != 0) {
                    this.$router.push({name:'consultdetails',params :{contentid:0,name:this.alias}});
                }

			},
			// 详情跳转
			Torouter(item) {
				this.$router.push({name:'consultdetails',params :{name:item}})
			},
			gotoPage(num) {

				this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:num}})
			},
			unfold: function() {
				var box = document.getElementById("zhedie");
				var unfold = document.getElementById('context-wrap');

				if(box.innerText == "展开") {
					box.innerText = "折叠"
					unfold.style.height = "100%";
				} else {
					box.innerText = "展开"
					unfold.style.height = (110) + 'px';
				}
			},
			handleScroll() {
				var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_right_list').scrollHeight; // 总高度
				var self = this;
				if((all - 20) < (top + client) && !this.loadShow) {
					this.page++;
					if(this.page > this.total_page) {
					    this.endShow = true;
						return;
					}
					this.loadShow = true;
					var spaseid = this.$route.params.name;
                    this.$axios.post('/api/pc/specialist', {
                        page: self.pages,
                        alias: spaseid
                    }).then(data => {
                        if (data.data.state) {
                            var homeListes = data.data.content;
                            JSON.stringify(homeListes);
                            var new_homeLists = self.synopsisLists.concat(homeListes);
                            self.synopsisLists = new_homeLists;
                            self.loadShow = false;
                        }
                    })
				}

			}
		},
        watch: {

            screenWidth (val) {
                if (!this.timer) {
                    this.screenWidth = val;
                    this.timer = true;
                    let that = this;
                    setTimeout(function () {
                        if(that.IsPC()&&(val<=544)){
                            that.specail=true
                        }else{
                            that.specail=false
                        }
                        that.timer = false
                    }, 300)
                }

            }
        },
		components: {
			tollHint,
            toast,
            articles

		}
	})
</script>
<style scoped>
    .offer:hover{
        cursor:pointer;
    }
    .reqiureClass{
        color:red;
        padding-right:5px;
    }
    .myBtn{
        width:60px;
        height:30px;
        display:block;
        position:absolute;
        top:20px;
        right:20px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
        text-align:center;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    #home_right_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
    .myBtn:hover{
        cursor:pointer;
    }
</style>
